export default "__VITE_ASSET__DGl9w4F0__"